import React from 'react';
import PropTypes from 'prop-types';
import css from './InterventionName.scss';
import { SFEntityID } from 'utils/types';
import { getInterventionIcon } from 'utils/icons';
import { isEmpty } from 'lodash';

export default class InterventionName extends React.Component {

  get cardData() {
    return {
      'data:card-type': 'intervention',
      'data:card-id': `{personId: ${this.props.studentId}, interventionId: ${this.props.interventionId}}`
    };
  }

  get interventionIcon() {
    return <i className={`fa fa-fw sf-card-trigger unbound ${getInterventionIcon(this.props.interventionType)}`}
              {...this.cardData} />
  }

  get interventionTrigger() {
    return isEmpty(this.props.interventionTrigger) ? null :
      <div className={css['intervention-context']}><b>Context:</b> {this.props.interventionTrigger}</div>
  }

  render() {
    return <React.Fragment>
      {this.interventionIcon} {this.props.interventionName}
      {this.interventionTrigger}
    </React.Fragment>
  }

}

InterventionName.propTypes = {
  interventionId: SFEntityID.isRequired,
  interventionName: PropTypes.string.isRequired,
  interventionTrigger: PropTypes.string,
  interventionType: PropTypes.string.isRequired,
  studentId: SFEntityID.isRequired
};
